import React from 'react'
import { connect } from 'react-redux'
import uuidv4 from 'uuid/v4'
import { Modal, Icon, ErrorBoundary } from 'components'
import { config } from 'cmw-goaltools'
const { defaults, adjustDefaults } = config

function New(props) {
  const { profile, createGoal, setActiveGoal, history } = props
  return (
    <Modal title="Add New Goal" handleClose={() => history.goBack()}>
      <div className="new-goal">
        <ErrorBoundary>
          <ul>
            {Object.values(defaults).map((goal, idx) => (
              <li
                key={idx}
                onClick={() => {
                  const id = uuidv4()
                  createGoal(
                    { ...goal, ...adjustDefaults(profile.age, goal.category) },
                    id
                  )
                  setActiveGoal(id)
                  history.replace(`/edit/${id}`)
                }}
              >
                <div className="new-goal--title">
                  <Icon name={goal.icon} />
                  <h5>{goal.title}</h5>
                </div>
                <div className="new-goal--desc">{goal.description}</div>
              </li>
            ))}
          </ul>
        </ErrorBoundary>
      </div>
    </Modal>
  )
}

export default connect(
  state => ({ profile: state.profile }),
  { ...require('store/actions') }
)(New)



// WEBPACK FOOTER //
// ./src/components/modals/New.js